import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function FlashFloodDamagesLayer({
  currentSelectedDamageLayer,
  customLegendSelection,
  map,
}) {
  const currentLegendSelection = useSelector(state => state.legend.legendSelection);
  const legendSelection = customLegendSelection || currentLegendSelection;
  const dispatch = useDispatch()
  const { minTotalDamage, maxTotalDamage } = currentSelectedDamageLayer || { minTotalDamage: '', maxTotalDamage: '' }
  const currentBaseMapStyle = useSelector(state => state.maplibreMap.currentBaseMapStyle)
  
  useEffect(() => {
    if (currentSelectedDamageLayer) {
      if (!map.getSource('building-damages')) {
        map.addSource('building-damages', {
          type: 'geojson',
          data: currentSelectedDamageLayer,
        });
      } else {
        map.getSource('building-damages').setData(currentSelectedDamageLayer);
      }
    }
  }, [currentSelectedDamageLayer, map, currentBaseMapStyle]);
  
  useEffect(() => {
    if (legendSelection === 'classes' || minTotalDamage !== maxTotalDamage) {
      const paint = legendSelection === 'classes' 
        ? [
          'step',
          ['get', 'peValue'],
          '#2b3990',
          0.5, '#93268f',
          2.5, '#c41d69',
          5, '#ed1c24',
        ] : [
          'interpolate',
          ['linear'],
          ['get', 'peValue'],
          minTotalDamage, '#2b3990',
          maxTotalDamage, '#ed1c24',
        ]
  
      map.addLayer({
        id: 'building-damages',
        type: 'fill',
        source: 'building-damages',
        paint: {
          'fill-color': paint,
          'fill-outline-color': '#777',
        },
      }, 'z-index-4');
    }
  
    return () => {
      if (map && !map._removed) {
        if (map.getLayer('building-damages')) {
          map.removeLayer('building-damages');
        }
    
        if (map.getSource('building-damages')) {
          map.getSource('building-damages');
        }
      }
    };
  }, [map, legendSelection, dispatch, minTotalDamage, maxTotalDamage, currentBaseMapStyle]);

  return null
}

export default FlashFloodDamagesLayer